<template>
  <div data-dusk="single-policies">
    <dd-header-card  header="Losse Polissen">
      <dd-main-table :rounded="true" :has-select="false" :headers="policyTableHeaders" :rows="policies">

      </dd-main-table>
    </dd-header-card>
  </div>
</template>

<script>
import {mapGetters } from "vuex";

export default {
  name: "PoliciesComponent",
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  computed: {
    ...mapGetters('$_policy_page', {
      policyTableHeaders: 'policyTableHeaders',
      policies: 'policies',
    }),
  }
}
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
